module.exports = __webpack_public_path__ + "static/media/wave-5.3302a96f.svg";